import { makeAutoObservable, reaction } from "mobx";
export class FulfillmentFormReactions {
    constructor(params) {
        this._dispose = null;
        this.purchaseOrderFulfillmentTime = params.purchaseOrderFulfillmentTime;
        // TODO: remove this dependency
        this.fulfillmentFormController = params.fulfillmentFormController;
        makeAutoObservable(this);
    }
    initialize() {
        if (this._dispose) {
            throw new Error("FulfillmentFormReactions has been already initialized");
        }
        // Reset fulfillment time on purchase order payload preorder change
        this._dispose = reaction(() => this.purchaseOrderFulfillmentTime.isPreorder, () => {
            if (this.purchaseOrderFulfillmentTime.type === "Online" &&
                this.purchaseOrderFulfillmentTime.fulfillmentTime !== null &&
                this.purchaseOrderFulfillmentTime.fulfillmentTime.type === "OnTime") {
                this.purchaseOrderFulfillmentTime.fulfillmentTime = null;
            }
        });
    }
    dispose() {
        if (this._dispose) {
            this._dispose();
        }
    }
}
